import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import Stack from '@mui/material/Stack';
import { Title } from '@/components/atoms/Title/Title';

export const CareProviderRegulatorsBanner = () => {
  return (
    <Stack sx={{ gap: sp[24], p: sp[24] }}>
      <Title isNoMargin isCenter>
        Our providers are regulated by
      </Title>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          height: '100%',
          justifyContent: 'space-around',
          alignItems: 'center',
          mb: sp[32],
          gap: sp[32],
          flexDirection: { xs: 'column', md: 'row' },
          '& > img': {
            objectFit: 'contain',
            height: '50px',
            maxHeight: '50px',
          },
        }}
      >
        <img src='/images/disclosure-scotland.png' alt='Disclosure Scotland' />
        <img src='/images/CQC.png' alt='Care Inspectorate' />
        <img
          src='/images/disclosure-and-barring-service.png'
          alt='Disclosure and Barring Service'
        />
        <img src='/images/care-inspectorate.png' alt='Care Inspectorate' />
      </Box>
    </Stack>
  );
};

export default CareProviderRegulatorsBanner;
